/**
 * Resolves the shop name shown on a card.
 * Content-builder `entity_name` can be a string, empty, or a leftover translation map.
 * `.trim()` on a non-string throws and blanks the title binding.
 */
export function resolveEntityDisplayName(options: {
  override?: unknown;
  entityName?: unknown;
  fallbackName?: unknown;
}): string {
  return firstNonEmptyText(options.override, options.entityName, options.fallbackName);
}

export function asDisplayText(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return '';
  }

  const entries = Object.entries(value as Record<string, unknown>);
  if (entries.length === 0 || !entries.every(([, nested]) => typeof nested === 'string')) {
    return '';
  }

  for (const [, text] of entries) {
    const trimmed = (text as string).trim();
    if (trimmed) {
      return trimmed;
    }
  }

  return '';
}

function firstNonEmptyText(...values: unknown[]): string {
  for (const value of values) {
    const text = asDisplayText(value);
    if (text) {
      return text;
    }
  }

  return '';
}
